import clsx from "clsx"
import { useMemo } from "react"

import { faIcon } from "@utils/faIcon"

import { TruncatableText } from "@particles/index"

import { Icon } from "@atoms/index"

import { Table } from "@organisms"

import styles from "./TextCell.module.scss"
import { TextCellProps } from "./TextCell.types"

export default function TextCell(props: TextCellProps) {
    const { variant = "primary", content, isLoading, cellWidth, showIcon = false, alignment = "left" } = props

    const renderIcon = useMemo(() => {
        if (variant === "primary") {
            return faIcon({ name: "circle-question", style: "solid" })
        } else if (variant === "success") {
            return faIcon({ name: "circle-check", style: "solid" })
        } else if (variant === "warning" || variant === "caution") {
            return faIcon({ name: "triangle-exclamation", style: "solid" })
        } else if (variant === "dangerous") {
            return faIcon({ name: "circle-xmark", style: "solid" })
        } else {
            return faIcon({ name: "circle-question", style: "solid" })
        }
    }, [variant])

    if (!content) {
        return <Table.Cells.NoValueCell />
    } else if (isLoading) {
        return <Table.Cells.SkeletonCell variant="text" cellWidth={cellWidth} />
    } else {
        return (
            <div
                className={clsx(styles.base, styles[variant], styles[`${alignment}Align`])}
                style={{ width: cellWidth }}
            >
                {showIcon && (
                    <Icon containerClassName={styles.icon} icon={renderIcon} size={14} container="fixedHeight" />
                )}
                <TruncatableText
                    tooltipOnTruncate={true}
                    tooltipPlacement="bottom"
                    text={content}
                    className={styles.content}
                />
            </div>
        )
    }
}
